import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditApi, AuditLogFilters } from '@/api/audit';

/**
 * Query key factory for audit logs
 */
export const auditKeys = {
  all: ['audit-logs'] as const,
  lists: () => [...auditKeys.all, 'list'] as const,
  list: (filters: AuditLogFilters) => [...auditKeys.lists(), filters] as const,
};

/**
 * Hook to fetch paginated list of audit log entries
 */
export function useAuditLogs(filters: AuditLogFilters) {
  return useQuery({
    queryKey: auditKeys.list(filters),
    queryFn: () => auditApi.getAll(filters),
    placeholderData: keepPreviousData,
    staleTime: 30000, // 30 seconds
  });
}
